/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apiKeysRotate } from "../../funcs/apiKeysRotate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1ApiKeysRotateRequestBody$inboundSchema,
};

export const tool$apiKeysRotate: ToolDefinition<typeof args> = {
  name: "api-keys_rotate",
  description: `Rotate API key

Rotates an API key while maintaining its configuration`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apiKeysRotate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
